if (!window.basisProductTabsInitialized) {
  window.basisProductTabsInitialized = true;

  function initializeProductTabs(root = document) {
    for (const list of root.querySelectorAll('[data-product-tabs] [role="tablist"]')) {
      const active = list.querySelector('[aria-selected="true"]');
      if (!active) continue;
      for (const tab of list.querySelectorAll('[role="tab"]')) {
        const panel = list.closest('[data-product-tabs]').querySelector(`#${tab.getAttribute('aria-controls')}`);
        if (panel) panel.hidden = tab !== active;
      }
    }
  }
  initializeProductTabs();
  document.addEventListener('shopify:section:load', (event) => initializeProductTabs(event.target));

  function activateProductTab(tab, moveFocus) {
    const list = tab.closest('[role="tablist"]');
    if (!list) return;
    const root = list.closest('[data-product-tabs]');
    for (const candidate of list.querySelectorAll('[role="tab"]')) {
      const active = candidate === tab;
      candidate.setAttribute('aria-selected', String(active));
      candidate.tabIndex = active ? 0 : -1;
      const panel = root.querySelector(`#${candidate.getAttribute('aria-controls')}`);
      if (panel) panel.hidden = !active;
    }
    tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    if (moveFocus) tab.focus();
  }

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-product-tabs] [role="tab"]');
    if (tab) activateProductTab(tab, false);
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('[data-product-tabs] [role="tab"]');
    if (!tab) return;
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];
    const index = tabs.indexOf(tab);
    let next = index;
    if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
    else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = tabs.length - 1;
    else return;
    event.preventDefault();
    activateProductTab(tabs[next], true);
  });
}
